
import React, { useEffect, useState } from 'react';
import Heading from '../../../../../common/element/Heading';
import { setBreadcrumbs } from '../../../../../redux/Admin/breadcrumbsSlice';
import { useDispatch, useSelector } from 'react-redux';
import { setManagementName, resetManagementName } from '../../../../../redux/Admin/managementViewSlice';
import Overview from './Tabs/Employee/OverViewEmployee';
import EmployeeView from './Tabs/Employee/EmployeeView';
import { useLocation, useNavigate } from 'react-router-dom';

import SessionList from './Tabs/Employee/SessionView';
import { getCompanyEmployeeInfo } from '../../../../../redux/Employee/employeesSlice';
import { selectCompanyEmployeeInfo } from '../../../../../redux/Employee/employeesSelector';
import { CompanyAvatar } from '../../../../../common/element/CompanyAvatar/CompanyAvatar';

import ImagePreviewModal from '../../../../../common/ImagePreviewModal/ImagePreviewModal';

const ViewManagement = () => {
  const dispatch = useDispatch();
  const location = useLocation();
  const navigate = useNavigate();

  // ✅ Read URL params
  const searchParams = new URLSearchParams(location.search);
  const managementId = searchParams.get('managementId');
  const batchId = searchParams.get("batchId");
  const coachId = searchParams.get("coachId");
  const sessionView = searchParams.get('sessionView');
  const companySessionView = searchParams.get('companySessionView');
  const tabFromUrl = searchParams.get('tab') || 'managementOverview';
  const companyId = searchParams.get('companyId');
  const sessionId = searchParams.get('sessionId');
  const sessionName = searchParams.get('sessionName');
  const companyEmployeeInfo = useSelector(selectCompanyEmployeeInfo);
  const source = companyEmployeeInfo || {};
  console.log(source, "sourcesource")
  const empName = source?.employee_name || source?.employeeName || source?.name || source?.full_name || '-';
  const empCompany = source?.company_name || source?.companyName || source?.company || '';
  const empMobile = source?.employee_mobile_number || source?.employee_mobile || source?.mobile || source?.phone || '';
  const empEmail = source?.employee_email || source?.employeeEmail || source?.email || '';
  const isActive = source?.isActive;
  const storedManagementName = useSelector((state) => state.managementView?.managementName);
  const storedSessionName = useSelector((state) => state.sessionView?.sessionName);
  const empID = searchParams.get('empId');
  console.log(sessionView, "sessionViewsessionViewsessionView")
  // ✅ Set active tab from URL
  const [activeTab, setActiveTab] = useState(tabFromUrl);

  // ✅ NEW: State for the Image Preview Modal
  const [imageModal, setImageModal] = useState({
    isOpen: false,
    url: "",
    alt: "",
  });

  // Update tab when URL change
  useEffect(() => {
    setActiveTab(tabFromUrl);
  }, [tabFromUrl]);

  // Update URL on tab change
  const handleTabChange = (tabId) => {
    setActiveTab(tabId);
    const params = new URLSearchParams(location.search);
    params.set('tab', tabId);
    params.delete('managementId');
    params.delete('sessionView');

    navigate(`?${params.toString()}`, { replace: true });
  };

  useEffect(() => {
    // If we have a companyId in query (or we're on companyview path) prefer company-style breadcrumbs
    const isCompanyContext = !!companyId || location.pathname.includes('/companies/companyview');

    const storedName = storedManagementName || empName || '';
    const managementLabel = storedName || 'View Management';

    if (isCompanyContext && activeTab === 'managementSessions' && (sessionView === 'view' || companySessionView === 'view')) {
      dispatch(
        setBreadcrumbs([
          { label: 'Companies', url: '/companies', home: '/companies' },
          { label: 'View Company', url: `/companies/companyview?companyId=${companyId}&tab=management` },
          { label: managementLabel, url: `/companies/companyview?companyId=${companyId}&tab=managementSessions&empId=${empID}` },
          { label: storedSessionName || sessionName || 'Session View', url: `/companies/companyview?companyId=${companyId}&tab=managementSessions&empId=${empID}&sessionId=${sessionId}&companySessionView=view` },
        ])
      );
      return;
    }

    // If we're viewing a session but NOT in a company context, show management-style breadcrumbs
    if (!isCompanyContext && (sessionView === 'view' || companySessionView === 'view')) {
      const viewUrl = `/management/view?empId=${empID}&tab=${activeTab}${sessionId ? `&sessionId=${sessionId}` : ''}&sessionView=view`;
      dispatch(
        setBreadcrumbs([
          { label: 'Management', url: '/management', home: '/companies' },
          { label: managementLabel, url: `management/view?empId=${empID}&tab=${activeTab}` },
          { label: storedSessionName || sessionName || 'Session View', url: `${viewUrl}` },
        ])
      );
      return;
    }

    // Fallback: when inside company view but not session view, set base company breadcrumbs
    if (isCompanyContext) {
      dispatch(
        setBreadcrumbs([
          { label: 'Companies', url: '/companies', home: '/companies' },
          { label: 'View Company', url: `/companies/companyview?companyId=${companyId}&tab=management` },
          { label: managementLabel, url: `/companies/companyview?companyId=${companyId}&tab=managementSessions&empId=${empID}&sessionId=${sessionId}&companySessionView=view` },
        ])
      );
      return;
    }

    // Default logic for 'Management' route (create a consistent management->view URL)
    if (!managementId && !sessionView) {
      const viewUrl = `/management/view?empId=${empID}&tab=${activeTab}${sessionId ? `&sessionId=${sessionId}` : ''}&sessionView=view`;
      dispatch(
        setBreadcrumbs([
          { label: 'Management', url: '/management', home: '/companies' },
          { label: managementLabel, url: viewUrl },
        ])
      );
    }
  }, [dispatch, location.pathname, managementId, sessionView, companyId, empID, activeTab, sessionId, companySessionView, storedManagementName, empName, storedSessionName, sessionName]);

  const tabs = [
    { id: 'managementOverview', label: 'Management Overview' },
    { id: 'managementSessions', label: 'Sessions' },  // ✅ Changed here
  ];


  useEffect(() => {


    dispatch(getCompanyEmployeeInfo({ companyEmployeeId: empID }));

  }, [empID, dispatch]);

  // reset management name when leaving this view (but not on full page reload)
  useEffect(() => {
    const isReload = { current: false };
    const onBeforeUnload = () => { isReload.current = true; };
    window.addEventListener('beforeunload', onBeforeUnload);
    return () => {
      window.removeEventListener('beforeunload', onBeforeUnload);
      if (!isReload.current) {
        dispatch(resetManagementName());
      }
    };
  }, [dispatch]);

  // persist management name (employee name shown in management view) so breadcrumbs can use it and it survives refresh
  useEffect(() => {
    if (source && (source.employee_name || source.name || source.full_name)) {
      const name = source.employee_name || source.name || source.full_name;
      dispatch(setManagementName(name));
    }
  }, [source, dispatch]);

  // ✅ NEW: Image Preview Handlers
  const openImagePreview = () => {
    if (!source?.profile_image) return;
    setImageModal({ 
      isOpen: true, 
      url: source.profile_image, 
      alt: empName || "Profile Image" 
    });
  };

  const closeImagePreview = () => {
    setImageModal({ isOpen: false, url: "", alt: "" });
  };

  return (
    <div>
      <div className="flex justify-between mb-5">
        <div className="w-full">
          <div className="flex items-center gap-4 mb-6">
            
            {/* ✅ NEW: Wrap CompanyAvatar in clickable div */}
            <div 
              onClick={openImagePreview}
              className={source?.profile_image ? "cursor-pointer hover:opacity-80 transition" : ""}
              title={source?.profile_image ? "View Profile Image" : ""}
            >
              <CompanyAvatar logo={source?.profile_image} name={empName} />
            </div>

            <div>
              <div className="w-80 h-10 text-start">
                {/* Prefer explicit fields from payload and provide safe fallbacks */}
                <Heading>{empName}</Heading>
              </div>

              <div className="flex items-center gap-3 mt-1">
                <div className={`flex items-center gap-1 px-3 py-0.5 ${isActive ? "bg-[#ECFDF3]" : "bg-[#FEF3F2]"} rounded-[16px]`}>
                  <div className={`w-2 h-2 ${isActive ? "bg-green-500" : "bg-red-500"} rounded-full`} />
                  {/* show company name if present */}
                  <span className={`font-lato font-medium text-[14px] ${isActive ? "text-[#027A48]" : "text-[#B42318]"}`}>
                    {isActive ? "Active" : "Inactive"}
                  </span>
                </div>
                <span className="font-lato font-medium text-[14px] text-[#1D2939] flex items-center gap-2">

                  <span>{empEmail}</span> •  <span>{source.employee_mobile_number}</span>
                </span>


                {/* show email if present */}

              </div>
            </div>
          </div>
          {/* Header Hide when Viewing Management Detail */}
          {(!managementId && sessionView !== "view" && companySessionView !== "view") && (
            <>


              {/* Tabs */}
              <div className="flex gap-0 p-1 bg-[#FFF4E5] border border-[#FFF4E5] rounded-lg mb-6">
                {tabs.map((tab) => (
                  <button
                    key={tab.id}
                    onClick={() => handleTabChange(tab.id)}
                    className={`flex-1 text-sm font-normal transition-colors py-2 px-3 rounded-md ${activeTab === tab.id
                      ? 'text-gray-900 bg-white shadow-[0px_1px_3px_rgba(16,24,40,0.1),0px_1px_2px_rgba(16,24,40,0.06)]'
                      : 'text-gray-600 bg-[#FFF4E5]'
                      }`}
                  >
                    {tab.label}
                  </button>
                ))}
              </div>
            </>
          )}

          {/* Tab Views */}
          {activeTab === 'managementOverview' && <Overview companyData={companyEmployeeInfo} />}

          {/* ✅ Changed 'sessions' to 'managementSessions' */}
          {activeTab === 'managementSessions' && (sessionView === "view" || companySessionView === "view") && (
            <EmployeeView managementId={managementId} />
          )}

          {activeTab === 'managementSessions' && (sessionView !== "view" && companySessionView !== "view") && (
            <SessionList />
          )}

        </div>
      </div>

      {/* ✅ NEW: Render the Image Preview Modal */}
      <ImagePreviewModal
        isOpen={imageModal.isOpen}
        onClose={closeImagePreview}
        imageUrl={imageModal.url}
        altText={imageModal.alt}
      />
      
    </div>
  );
};

export default ViewManagement;
